module.exports = __webpack_public_path__ + "static/media/adversarial-va.3e8ce054.png";